/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountTransferDto } from '../models/AccountTransferDto';
import type { CreateTransferAccountDto } from '../models/CreateTransferAccountDto';
import type { CustomerCommentRequestDto } from '../models/CustomerCommentRequestDto';
import type { CustomerCryptoTransactionDto } from '../models/CustomerCryptoTransactionDto';
import type { CustomerDailyChangeDto } from '../models/CustomerDailyChangeDto';
import type { CustomerFiatTransactionDto } from '../models/CustomerFiatTransactionDto';
import type { CustomerStatementDto } from '../models/CustomerStatementDto';
import type { CustomerTransactionDetailDtoPaginationResultDto } from '../models/CustomerTransactionDetailDtoPaginationResultDto';
import type { CustomerTransactionDtoPaginationResultDto } from '../models/CustomerTransactionDtoPaginationResultDto';
import type { Operation } from '../models/Operation';
import type { PendingWithdrawalDetailDtoPaginationResultDto } from '../models/PendingWithdrawalDetailDtoPaginationResultDto';
import type { TradingType } from '../models/TradingType';
import type { TransactionCurrencyType } from '../models/TransactionCurrencyType';
import type { WalletAccountDto } from '../models/WalletAccountDto';
import type { WalletConfigurationDto } from '../models/WalletConfigurationDto';
import type { WalletType } from '../models/WalletType';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class WalletService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * @param tradingType
     * @returns WalletAccountDto Success
     * @throws ApiError
     */
    public getApiWalletAccounts(
        tradingType?: TradingType,
    ): CancelablePromise<Array<WalletAccountDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/accounts',
            query: {
                'tradingType': tradingType,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns CustomerDailyChangeDto Success
     * @throws ApiError
     */
    public getApiWalletDailyChange(): CancelablePromise<CustomerDailyChangeDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/daily-change',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param currencyType
     * @param currency
     * @param page
     * @param count
     * @param dateFrom
     * @param dateTo
     * @param accountTradingType
     * @returns CustomerTransactionDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiWalletTransactions(
        currencyType?: TransactionCurrencyType,
        currency?: string,
        page: number = 1,
        count: number = 10,
        dateFrom?: string,
        dateTo?: string,
        accountTradingType?: TradingType,
    ): CancelablePromise<CustomerTransactionDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/transactions',
            query: {
                'currencyType': currencyType,
                'currency': currency,
                'page': page,
                'count': count,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'accountTradingType': accountTradingType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param transactionId
     * @returns CustomerCryptoTransactionDto Success
     * @throws ApiError
     */
    public getApiWalletCryptoTransactions(
        transactionId: number,
    ): CancelablePromise<CustomerCryptoTransactionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/crypto-transactions/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param transactionId
     * @returns CustomerFiatTransactionDto Success
     * @throws ApiError
     */
    public getApiWalletFiatTransactions(
        transactionId: number,
    ): CancelablePromise<CustomerFiatTransactionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/fiat-transactions/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param currencyType
     * @param currency
     * @param page
     * @param count
     * @param dateFrom
     * @param dateTo
     * @returns CustomerTransactionDetailDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiWalletTransactionsDetails(
        currencyType?: WalletType,
        currency?: string,
        page: number = 1,
        count: number = 100,
        dateFrom?: string,
        dateTo?: string,
    ): CancelablePromise<CustomerTransactionDetailDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/transactions-details',
            query: {
                'currencyType': currencyType,
                'currency': currency,
                'page': page,
                'count': count,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param transactionId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putApiWalletFiatTransactionsCustomerComment(
        transactionId: number,
        requestBody?: CustomerCommentRequestDto,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/wallet/fiat-transactions/{transactionId}/customer-comment',
            path: {
                'transactionId': transactionId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param transactionId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putApiWalletCryptoTransactionsCustomerComment(
        transactionId: number,
        requestBody?: CustomerCommentRequestDto,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/wallet/crypto-transactions/{transactionId}/customer-comment',
            path: {
                'transactionId': transactionId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param dateFrom
     * @param dateTo
     * @param operation
     * @returns CustomerStatementDto Success
     * @throws ApiError
     */
    public getApiWalletStatements(
        dateFrom: string,
        dateTo: string,
        operation?: Array<Operation>,
    ): CancelablePromise<CustomerStatementDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/statements',
            query: {
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'operation': operation,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param currency
     * @param page
     * @param count
     * @returns PendingWithdrawalDetailDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiWalletPendingWithdrawals(
        currency?: string,
        page: number = 1,
        count: number = 100,
    ): CancelablePromise<PendingWithdrawalDetailDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/pending-withdrawals',
            query: {
                'currency': currency,
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns number Success
     * @throws ApiError
     */
    public postApiWalletAccountsTransfers(
        requestBody?: CreateTransferAccountDto,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet/accounts/transfers',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param transferId
     * @returns AccountTransferDto Success
     * @throws ApiError
     */
    public getApiWalletAccountsTransfers(
        transferId: number,
    ): CancelablePromise<AccountTransferDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/accounts/transfers/{transferId}',
            path: {
                'transferId': transferId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns WalletConfigurationDto Success
     * @throws ApiError
     */
    public getApiWalletConfiguration(): CancelablePromise<WalletConfigurationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
